import { OnInit, ElementRef, AfterViewInit, QueryList, } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { BsModalEventsEmitter } from 'src/app/modules/shared/events/bsModal.events';
import { forkJoin, Observable } from 'rxjs';
import { getCookie } from '../../../utilities/cookie.utilities';
import { PricingService } from '../../../../pricing/services/pricing.service';
import { UsersService } from '../../../services/users.service';
import { AppLoadingEventsEmitter } from '../../../events/loading.events';
import { LocalisationService } from '../../../services/localisation.service';
import { Router } from '@angular/router';
var UpgradeComponent = /** @class */ (function () {
    function UpgradeComponent(bsModalRef, pricingService, usersService, appIsLoadingEventsEmitter, bsModalEventsEmitter, localisationService, router) {
        this.bsModalRef = bsModalRef;
        this.pricingService = pricingService;
        this.usersService = usersService;
        this.appIsLoadingEventsEmitter = appIsLoadingEventsEmitter;
        this.bsModalEventsEmitter = bsModalEventsEmitter;
        this.localisationService = localisationService;
        this.router = router;
        this.mobileWidth = 576;
        this.pricings = null;
        this.currentUserIsReferral = false;
        this.discountCode = null;
        this.showYearlyPricing = false;
        this.masterProfile = false;
    }
    UpgradeComponent.prototype.ngOnInit = function () {
        this.masterProfile = (this.usersService.userProfile && this.usersService.userProfile.is_master_profile === true);
        this.load().subscribe();
    };
    UpgradeComponent.prototype.getPricing = function () {
        if (this.pricings !== null && this.pricings.length > 0) {
            return this.pricings[0];
        }
        return null;
    };
    UpgradeComponent.prototype.load = function () {
        var _this_1 = this;
        return new Observable(function (observer) {
            forkJoin([
                _this_1.pricingService.getPricings(),
                _this_1.pricingService.getPaymentMethods()
            ]).subscribe(function (_a) {
                var pricings = _a[0], paymentMethods = _a[1];
                var new_pricings = pricings.filter(function (pricing) { return pricing.show_for_master_profiles === _this_1.masterProfile; });
                _this_1.pricings = new_pricings.sort(function (a, b) { return +a.amounts[0].monthly_price - +b.amounts[0].monthly_price; });
                _this_1.currentUserIsReferral = false;
                // detect discount cookie
                var discountCookie = getCookie('discount');
                if (!(discountCookie === null || discountCookie.length <= 0)) {
                    _this_1.applyDiscountForAllPlans(discountCookie);
                }
                _this_1.pricings = _this_1.pricings.filter(function (pricing) { return parseFloat(pricing.amounts[0].monthly_price) > 0; });
                observer.next(true);
                observer.complete();
            });
        });
    };
    UpgradeComponent.prototype.applyDiscountForAllPlans = function (discountCode) {
        var _this_1 = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.pricingService.getDiscount({ 'discount_code': discountCode }).subscribe(function (discount) {
            _this_1.discountCode = discount;
            // tslint:disable-next-line:forin
            for (var pricingIndex in _this_1.pricings) {
                // tslint:disable-next-line:forin
                for (var amountIndex in _this_1.pricings[pricingIndex].amounts) {
                    // @ts-ignore
                    if (_this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price <= 0) {
                        continue;
                    }
                    // @ts-ignore
                    _this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price = (_this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price - (_this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price * (_this_1.getDiscountPercentageByLocale(_this_1.discountCode) / 100))).toFixed(2);
                }
            }
            _this_1.pricings = _this_1.pricings.sort(function (a, b) { return +a.amounts[0].monthly_price - +b.amounts[0].monthly_price; });
            _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        }, function () {
            _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    };
    UpgradeComponent.prototype.ngAfterViewInit = function () {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
        else {
            this.defaultScreen();
        }
        this.openAllTooltips();
    };
    UpgradeComponent.prototype.getLanguagePricingAmount = function (pricing) {
        var language = this.localisationService.getLanguage();
        for (var amountIndex in pricing.amounts) {
            if (pricing.amounts[amountIndex].language.country_code === language) {
                // @ts-ignore
                return pricing.amounts[amountIndex];
            }
        }
        return null;
    };
    UpgradeComponent.prototype.toFullscreen = function () {
        var modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        var modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        var modal = this.wrapper.nativeElement.parentElement;
        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    };
    UpgradeComponent.prototype.defaultScreen = function () {
        var modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        var modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        var modal = this.wrapper.nativeElement.parentElement;
        modalDialog.style.borderRadius = '0';
        // modalDialog.style.display = 'flex';
        // modalDialog.style.margin = '0';
        // modalDialog.style.padding = '0';
        // modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = '564px';
        // modalDialog.style.minHeight = '100%';
        // modalDialog.style.height = '100%';
        // modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    };
    UpgradeComponent.prototype.onChoose = function () {
        this.router.navigate(['pricing']);
        this.bsModalRef.hide();
    };
    UpgradeComponent.prototype.openAllTooltips = function (disable_delay) {
        if (disable_delay === void 0) { disable_delay = false; }
        var _this = this;
        setTimeout(function () {
            _this.activeChecks.forEach(function (tooltip) {
                tooltip.open();
            });
        }, (disable_delay === true ? 100 : 1100));
    };
    UpgradeComponent.prototype.onYearlyPricingToggleChange = function (custom_value) {
        if (custom_value === void 0) { custom_value = null; }
        if (custom_value !== null) {
            this.showYearlyPricing = custom_value;
        }
        else {
            this.showYearlyPricing = !this.showYearlyPricing;
        }
        this.openAllTooltips(true);
    };
    return UpgradeComponent;
}());
export { UpgradeComponent };
